var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.5 0.5C8.53765 0.5 11 2.96235 11 6C11 9.03765 8.53765 11.5 5.5 11.5C2.46235 11.5 0 9.03765 0 6C0 2.96235 2.46235 0.5 5.5 0.5ZM5.5 2.7C5.35413 2.7 5.21424 2.75795 5.11109 2.86109C5.00795 2.96424 4.95 3.10413 4.95 3.25V6C4.95003 6.14586 5.008 6.28573 5.11115 6.38885L6.76115 8.03885C6.86488 8.13904 7.00381 8.19447 7.14802 8.19322C7.29223 8.19197 7.43018 8.13412 7.53215 8.03215C7.63412 7.93018 7.69197 7.79223 7.69322 7.64802C7.69447 7.50381 7.63904 7.36488 7.53885 7.26115L6.05 5.7723V3.25C6.05 3.10413 5.99205 2.96424 5.88891 2.86109C5.78576 2.75795 5.64587 2.7 5.5 2.7Z",
    fill: "url(#paint0_linear_21_72)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_72",
    x1: 10.2626,
    y1: 5.99998,
    x2: 0.276536,
    y2: 5.99998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeReminder);
export default __webpack_public_path__ + "static/media/time-reminder.c4d995e8258b94fb203db03910d8f8e9.svg";
export { ForwardRef as ReactComponent };